import apiClient from '@/shared/services/apiClient';

export interface AdminMembershipSummary {
    id: number;
    user_id: number;
    customer_name: string | null;
    customer_email: string | null;
    organization_id: number;
    organization_name: string | null;
    plan: string;
    status: string;
    amount_cents: number;
    current_period_start: string;
    current_period_end: string;
    next_charge_date: string | null;
    cancel_at_period_end: boolean;
}

export interface AdminMembershipListResult {
    memberships: AdminMembershipSummary[];
    total: number;
    page: number;
    page_size: number;
}

/**
 * Shape returned by the cancel endpoint — the BE `MembershipState`
 * (camelCase), distinct from the snake_case list-row `AdminMembershipSummary`.
 */
export interface MembershipState {
    id: number;
    plan: string;
    status: string;
    amountCents: number;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    nextChargeDate: string | null;
    cancelAtPeriodEnd: boolean;
    cancelledReason: string | null;
}

function toQuery(params: Record<string, unknown>): string {
    const usp = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null && v !== '') usp.set(k, String(v));
    }
    const s = usp.toString();
    return s ? `?${s}` : '';
}

export const AdminMembershipsService = {
    async list(page = 1, pageSize = 25, status = 'active'): Promise<AdminMembershipListResult> {
        return apiClient.get<AdminMembershipListResult>(
            `/api/admin/memberships${toQuery({page, page_size: pageSize, status})}`
        );
    },
    async cancel(id: number, body: {reason?: string} = {}): Promise<{membership: MembershipState}> {
        return apiClient.post(`/api/admin/memberships/${id}/cancel`, body);
    },
};

export default AdminMembershipsService;
